import { create } from 'zustand'

/**
 * Global filter context for Super Admin / Client Admin.
 * Used on overview/analytics pages to filter data by client/facility.
 * Each hook that needs filtering reads from this store directly.
 */
interface ContextState {
  /** Selected client ID (null = All Clients) */
  selectedClientId: string | null
  /** Selected facility ID (null = All Facilities) */
  selectedFacilityId: string | null

  setClient: (clientId: string | null) => void
  setFacility: (facilityId: string | null) => void
  resetFilters: () => void
}

export const useContextStore = create<ContextState>((set) => ({
  selectedClientId: null,
  selectedFacilityId: null,

  setClient: (clientId) =>
    set({ selectedClientId: clientId, selectedFacilityId: null }),

  setFacility: (facilityId) =>
    set({ selectedFacilityId: facilityId }),

  resetFilters: () =>
    set({ selectedClientId: null, selectedFacilityId: null }),
}))
